import React from 'react';
import InputField from '../input/inputField';
import { GENDER_OPTIONS } from '../../Constants/options/gender.options';
import { getSelectedOptionFromValue } from '../../Helper/options.helper';
import Dropdown from '../Dropdown/dropdown';
import { PARENTAL_RELATIONSHIP_OPTIONS } from '../../Constants/options/parentalRelationship.option';

interface Props {
  firstName: string;
  middleName: string;
  lastName: string;
  mobile: string;
  address: string;
  gender: string;
  parentalRelationship: string;
  onFirstNameChange: (firstName: string) => unknown;
  onMiddleNameChange: (middleName: string) => unknown;
  onlastNameChange: (lastName: string) => unknown;
  onMobileChange: (mobile: string) => unknown;
  onAddressChange: (address: string) => unknown;
  onGenderChange: (gender: string) => unknown;
  onParentalRelationShipChange: (relation: string) => unknown;
}
export const ParentDetails = ({
  firstName,
  middleName,
  lastName,
  mobile,
  address,
  gender,
  parentalRelationship,
  onFirstNameChange,
  onMiddleNameChange,
  onlastNameChange,
  onMobileChange,
  onAddressChange,
  onGenderChange,
  onParentalRelationShipChange,
}: Props) => {
  const selectedGenderOption = getSelectedOptionFromValue(
    GENDER_OPTIONS,
    gender
  );

  const selectedParentalRelationship = getSelectedOptionFromValue(
    PARENTAL_RELATIONSHIP_OPTIONS,
    parentalRelationship
  );

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-x-8">
      <InputField
        value={firstName}
        setValue={(value) => onFirstNameChange(value)}
        label="First name *"
        name="register-parents-firstname"
        isRequiredFocusonValidation
      />
      <InputField
        value={middleName}
        setValue={(value) => onMiddleNameChange(value)}
        label="Middle name"
        name="register-parents-middlename"
      />
      <InputField
        value={lastName}
        setValue={(lastName) => onlastNameChange(lastName)}
        label="Last name *"
        name="register-parents-lastname"
        isRequiredFocusonValidation
      />
      <InputField
        value={mobile}
        setValue={(mobile) => onMobileChange(mobile)}
        label="Mobile *"
        name="register-parents-mobile"
        isRequiredFocusonValidation
      />
      <InputField
        value={address}
        setValue={(address) => onAddressChange(address)}
        label="Address"
        name="register-parents-address"
        isRequiredFocusonValidation
      />
      <Dropdown
        label="Gender *"
        options={GENDER_OPTIONS}
        selectedOption={selectedGenderOption}
        setSelectedOption={(option) => {
          onGenderChange(option?.value as string);
        }}
      />

      <Dropdown
        label="Parental relationship *"
        options={PARENTAL_RELATIONSHIP_OPTIONS}
        selectedOption={selectedParentalRelationship}
        setSelectedOption={(option) => {
          onParentalRelationShipChange(option?.value as string);
        }}
      />
    </div>
  );
};
